// extracted by mini-css-extract-plugin
export default {"what":"ClaimedProfileBadge_what__4G1F9"};